import { MouseEvent, useEffect, useState } from 'react';

import { useSizeWithThrottle } from '~/core/hooks/useSizeWithThrottle';

export const useShareLinkPopper = (
    link: string
): {
    isOpen: boolean;
    handleClick: (event: MouseEvent<HTMLButtonElement>) => void;
    anchorElement: HTMLButtonElement | null;
    id: 'simple-popper' | undefined;
} => {
    const screenSize = useSizeWithThrottle();

    const [anchorElement, setAnchorElement] = useState<HTMLButtonElement | null>(null);

    const handleClose = () => {
        setAnchorElement(null);
    };

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        navigator.clipboard.writeText(link);
        setAnchorElement(event.currentTarget);

        setTimeout(() => {
            handleClose();
        }, 2000);
    };

    useEffect(() => {
        handleClose();
    }, [screenSize]);

    const isOpen = anchorElement !== null;
    const id = isOpen ? 'simple-popper' : undefined;

    return { handleClick, id, isOpen, anchorElement };
};
